module.exports = __webpack_public_path__ + "static/img/pay2.59254ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/pay2.png
// module id = i8g0
// module chunks = 1